import { render } from "./LabelRichTextEditor.vue?vue&type=template&id=c606b810&scoped=true"
import script from "./LabelRichTextEditor.vue?vue&type=script&lang=js"
export * from "./LabelRichTextEditor.vue?vue&type=script&lang=js"

import "./LabelRichTextEditor.vue?vue&type=style&index=0&id=c606b810&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c606b810"]])

export default __exports__